import { type ILANGUAGE } from "../constants/data";
import { useNuxtApp } from '#app';

export const changeLocale = (lang: ILANGUAGE) => {
  const { $i18n, $functions, $constants } = useNuxtApp();
  $i18n.global.locale.value = lang;
  $functions.setLocalStorage($constants.LOCAL_STORAGE.BOILER_PLATE_LANGUAGE, lang)
}

export const getCurrentLocale = () => {
  const { $i18n } = useNuxtApp();
  return $i18n.global.locale.value;
}